import ReactModal from "react-modal";

interface BillingInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const BillingInfoModal: React.FC<BillingInfoModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Billing Address Information"
      className="modal"
      overlayClassName="overlay"
    >
      <div className="text-center">
        <p>This billing address for verifying cardholder information only.</p>
      </div>
    </ReactModal>
  );
};

export default BillingInfoModal;
